import { CreditCard, RefreshCw } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const STATUS_COPY: Record<string, { title: string; description: string }> = {
  pending: {
    title: 'Pagamento pendente',
    description: 'Sua assinatura ainda não foi confirmada. Finalize o pagamento para liberar o acesso ao sistema.',
  },
  overdue: {
    title: 'Assinatura em atraso',
    description: 'A cobrança da sua assinatura está atrasada. Regularize o pagamento para continuar usando o Neurobit.',
  },
  canceled: {
    title: 'Assinatura cancelada',
    description: 'Sua assinatura foi cancelada. Entre em contato com o suporte ou assine novamente para reativar o acesso.',
  },
};

export const SubscriptionGatePage = () => {
  const { subscriptionIssue, checkAuth, logout } = useAuth();
  const copy = STATUS_COPY[subscriptionIssue?.status || 'pending'] || STATUS_COPY.pending;

  return (
    <div className="login-container relative">
      <div className="relative z-10 w-full max-w-md p-4 sm:p-6">
        <div className="card p-8 text-center space-y-5">
          <div className="w-14 h-14 mx-auto rounded-2xl bg-primary-50 dark:bg-primary-950/30 text-primary flex items-center justify-center">
            <CreditCard size={26} />
          </div>
          <div className="space-y-2">
            <h1 className="text-xl font-bold text-foreground">{copy.title}</h1>
            <p className="text-sm text-muted-foreground leading-relaxed">{copy.description}</p>
          </div>

          {subscriptionIssue?.checkoutUrl && (
            <a
              href={subscriptionIssue.checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full h-11 btn-primary flex items-center justify-center gap-2 text-xs uppercase tracking-wider"
            >
              Pagar agora
            </a>
          )}

          <button
            type="button"
            onClick={() => checkAuth()}
            className="w-full h-11 btn-outline flex items-center justify-center gap-2 text-xs uppercase tracking-wider"
          >
            <RefreshCw size={14} />
            Já paguei, verificar novamente
          </button>

          <button
            type="button"
            onClick={() => logout()}
            className="text-xs text-muted-foreground hover:text-primary transition-colors bg-transparent border-none p-0 cursor-pointer"
          >
            Sair da conta
          </button>
        </div>
      </div>
    </div>
  );
};
